<template>
  <DialogRoot v-slot="slotProps" data-slot="dialog" v-bind="forwarded">
    <slot v-bind="slotProps" />
  </DialogRoot>
</template>

<script setup>
defineOptions({ name: 'UiDialog' });
import { DialogRoot, useForwardPropsEmits } from 'reka-ui';

const props = defineProps({
  open: { default: undefined, type: Boolean, required: false },
  defaultOpen: { default: undefined, type: Boolean, required: false },
  modal: { default: undefined, type: Boolean, required: false },
  unmountOnHide: { default: undefined, type: Boolean, required: false },
});
const emits = defineEmits(['update:open']);

const forwarded = useForwardPropsEmits(props, emits);
</script>
